module.exports = __webpack_public_path__ + "img/img4.154a749a.svg";